import React, { FC } from "react";
import styles from "./MyInput.module.scss";

interface InputProps {
  value?: string | number | readonly string[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  type?: React.HTMLInputTypeAttribute;
  placeHolder?: string;
  name?: string;
  isInvalid?: boolean;
  id?: string;
  autoComplete?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  spellCheck?: boolean;
}

const MyInput: FC<InputProps> = ({
  value,
  onChange,
  className,
  type,
  placeHolder,
  name,
  isInvalid,
  id,
  autoComplete,
  inputMode,
  spellCheck
}) => {
  return (
    <div className={`${styles.myInput__wrapper} ${className || ""}`}>
      <input
        value={value}
        onChange={onChange}
        className={`${isInvalid ? styles.myInputInvalid : styles.myInput} ${className || ""}`}
        type={type}
        placeholder={placeHolder}
        name={name}
        id={id}
        autoComplete={autoComplete}
        inputMode={inputMode}
        spellCheck={spellCheck}
      />
    </div>
  );
};

export default MyInput;
